/* Example Usage

const toggleBannerHtml = new ToggleBannerHtml({
    open: false,
    openText: 'Öffnen',
    closeText: 'Schließen',
    text: '<p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr.</p>',
    actionButton: {
        text: 'Angebotsliste erstellen',
    },
    helpButton: {
        text: 'Warum brauche ich das?',
    },
});

console.log('toggleBannerHtml', toggleBannerHtml.toString());

*/

export default class ToggleBannerHtml {
    constructor(config) {
        this._config = config || {};
    }

    _getToggleButtonHtml() {
        return `
            <div class="rfct-toggle-banner__toggle-button-container" data-open-icon="expand_less" data-close-icon="close" data-open-text="${this._config.openText}" data-close-text="${this._config.closeText}">
                <button class="rfct-button rfct-button--primary">
                    <span class="rfct-button__inner">
                        <span class="rfct-button__label">
                            ${this._config.open ? this._config.closeText : this._config.openText}
                        </span>
                        <span class="rfct-button__icon material-icons">
                            expand_less
                        </span>
                    </span>
                </button>
            </div>`;
    }

    _getContentHtml() {
        return `
            <div class="rfct-toggle-banner__content">
                <div class="rfct-toggle-banner__text">
                    <p>${this._config.text}</p>
                </div>
                <div class="rfct-toggle-banner__actions">
                    ${this._config.actionButton && this._config.actionButton.text ? `
                        <div class="rfct-toggle-banner__action-button-container">
                            <button class="rfct-button rfct-button--secondary">
                                <span class="rfct-button__inner">
                                    <span class="rfct-button__label">${this._config.actionButton.text}</span>
                                </span>
                            </button>
                        </div>
                    ` : ''}
                    ${this._config.helpButton && this._config.helpButton.text ? `
                        <div class="rfct-toggle-banner__help-button-container">
                            <button class="rfct-button rfct-button--link">
                                <span class="rfct-button__inner">
                                    <span class="rfct-button__label">${this._config.helpButton.text}</span>
                                </span>
                            </button>
                        </div>
                    ` : ''}
                </div>
            </div>
        `;
    }

    toString() {
        return `
            <div class="rfct-toggle-banner${this._config.open ? ' rfct-toggle-banner--open' : ''}">
                <div class="rfct-toggle-banner__container container">
                    ${this._getToggleButtonHtml()}
                    ${this._getContentHtml()}
                </div>
            </div>
        `;
    }
}
